export enum MetodoPagamentoEnum {
  PIX = 6527407500,
  BOLETO = 9001,
  DCC = 9002 // Débito em Conta Corrente
}

export enum ProdutosVidaEnum {
  MAIS_SAUDE = 546, // SULAMERICA PROTEÇÃO MAIS SAÚDE
  VIDA_MAX = 641,
  AP_MAX = 643,
  FLEX_ESPECIALISTAS = 541,
  FLEX = 544,
  AP_FLEX = 941, // SULAMERICA AP - CF
  AP_ESTAG = 242, // SULAMERICA ACIDENTES PESSOAIS ESTAGIÁRIOS
  AP_ESTAG_CF = 748, // SULAMERICA ACIDENTES PESSOAIS ESTAGIÁRIOS
  AP_ESTAG_CF_MAR_ABERTO = 749 // SULAMERICA ACIDENTES PESSOAIS ESTAGIÁRIOS
}

export function getNumericEnumValuesAsArray<
  T extends Record<string | number, string | number>
>(enumObj: T): (number & T[keyof T])[] {
  return Object.values(enumObj)
    .filter((value): value is number => Number.isFinite(value))
    .map((value) => value as number & T[keyof T]);
}
